import React from 'react';
export function Footer() {
  return <footer className="w-full bg-pine" data-id="element-98" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl px-5 py-12 text-center" data-id="element-99" data-mp="3gezcj1s77n03">
        <h3 className="font-display text-2xl text-ember" data-id="element-100" data-mp="3ggka709t7m26">Troop Night Ready</h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-paper/70" data-id="element-101" data-mp="32p5qssbzpiul">
          The Grab-and-Lead Meeting Formula — grab the card, read it once, lead
          the meeting.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2.5 text-[13px] text-paper/70" data-id="element-102" data-mp="3ug3efhzi2d97">
          <a href="mailto:[SUPPORT_EMAIL]" className="hover:text-paper hover:underline" data-id="element-103" data-mp="37fsp0xcko14">
            [SUPPORT_EMAIL]
          </a>
          <a href="[INSTAGRAM_URL]" className="hover:text-paper hover:underline" data-id="element-104" data-mp="3lggcmv2uz5fm">
            [@handle]
          </a>
          <a href="[SITE_URL]" className="hover:text-paper hover:underline" data-id="element-105" data-mp="29z6tyark0hfd">
            [www.site.com]
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-paper/15 pt-5 text-xs leading-relaxed text-paper/50" data-id="element-106" data-mp="2eyjq5m4bf0um">
          Independent resource. Not affiliated with or endorsed by any Scouting
          or Guiding organization. Troop Night Ready is a planning resource for
          adult leaders: always follow your organization&apos;s safety and
          safeguarding rules and required adult ratios, and assess every site
          on the day. Not a certified first aid, tool-use or survival course.
          &copy; Troop Night Ready 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}